export default __webpack_public_path__ + "static/media/Phone@32.f73ea1d5.svg";